/* HI engine A/B gate — generated. Runs the code below only for the variant arm (body.hi-exp-exp-ed9ed7aa). */
(function () {
  var C = "hi-exp-exp-ed9ed7aa";
  var ran = false;
  function late(target, readyState) {
    var receiver = new Proxy(target, {
      get: function (t, p) {
        if (p === 'addEventListener') {
          return function (type, fn, opts) {
            if ((type === 'DOMContentLoaded' && readyState() !== 'loading') || (type === 'load' && readyState() === 'complete')) {
              setTimeout(function () { try { typeof fn === 'function' ? fn.call(t, new Event(type)) : fn.handleEvent(new Event(type)) } catch (e) { console.error(e) } }, 0);
              return;
            }
            return t.addEventListener(type, fn, opts);
          };
        }
        var v = Reflect.get(t, p, t);
        // A proxy, not bind: a bound function loses its own statics
        // (window.Promise.all, window.Object.assign).
        return typeof v === 'function'
          ? new Proxy(v, { apply: function (fn, self, args) { return Reflect.apply(fn, self === receiver ? t : self, args); } })
          : v;
      },
      set: function (t, p, v) { t[p] = v; return true; }
    });
    return receiver;
  }
  function run() {
    if (ran) return;
    ran = true;
    (function (document, window) {
/* A/B TEST VERSION (Intelligems, item 1f6f80f4): the test patch runs this only for the variant. */
/*
 * Token builder grid, large version (merchant requests, Nov 3): the token
 * counter, "Show selected only", tapping a token picture to add it, and
 * putting a tile back to its Add button after Add to Cart.
 * Loaded by sections/product-template-enamel-tokens.liquid when the large grid
 * is on. It never adds or removes tokens itself: every Add, - and + goes
 * through the theme's own buttons, so prices, tiers, engravings and Add to
 * Cart work exactly as before.
 */
if (!customElements.get('token-selected-bar')) {
  /*
   * <token-selected-bar>: the token counter under the search box. Counts every
   * chosen token on the page, the same set Add to Cart reads (product-form.js:
   * $('.tokenVariant.selected')), including tokens chosen under another
   * category tab or from the all-categories search. Its "Show selected only"
   * box sits beside it; ticking it puts .tokens--selected-only on the
   * builder, and token-grid-large.css hides the tokens not chosen.
   */
  customElements.define(
    'token-selected-bar',
    class TokenSelectedBar extends HTMLElement {
      connectedCallback() {
        this.container = this.closest('.tokens--container-vertical');
        this.form = this.closest('form');
        this.countEl = this.querySelector('[data-token-selected-count]');
        this.toggle = this.form && this.form.querySelector('[data-token-selected-only]');
        this.empty = this.container && this.container.querySelector('[data-token-selected-empty]');
        this.one = this.getAttribute('data-label-one');
        this.other = this.getAttribute('data-label-other');
        if (!this.container || !this.countEl) return;

        if (this.toggle) {
          this.toggle.addEventListener('change', () => {
            this.container.classList.toggle('tokens--selected-only', this.toggle.checked);
            const list = this.container.querySelector('.tokensList');
            if (list) list.scrollTop = 0;
            this.render();
          });
        }
        // The theme changes quantities in its own click handlers; recount
        // after them. The class watcher catches changes made without a click
        // (the selection clearing after Add to Cart, a category tab swapping
        // lists).
        this.later = () => {
          setTimeout(() => this.render(), 0);
          setTimeout(() => this.render(), 350);
        };
        document.addEventListener('click', this.later);
        document.addEventListener('keyup', this.later);
        this.mo = new MutationObserver(this.later);
        this.mo.observe(this.form || document.body, { subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
        this.render();
      }

      disconnectedCallback() {
        if (this.later) {
          document.removeEventListener('click', this.later);
          document.removeEventListener('keyup', this.later);
        }
        if (this.mo) this.mo.disconnect();
      }

      count() {
        let total = 0;
        document.querySelectorAll('.tokenVariant.selected').forEach((row) => {
          const input = row.querySelector('input.quantity');
          const qty = input ? parseInt(input.value, 10) : 0;
          total += qty > 0 ? qty : 0;
        });
        return total;
      }

      render() {
        const n = this.count();
        const text = n + ' ' + (n === 1 ? this.one : this.other);
        if (this.countEl.textContent !== text) this.countEl.textContent = text;
        if (this.empty) this.empty.hidden = !(this.toggle && this.toggle.checked && n === 0);
      }
    }
  );
}

(function () {
  // The A/B test can run this file after the page has loaded, when
  // document.currentScript is null: find the tag by its file name then.
  var script = document.currentScript || document.querySelector('script[src*="token-grid-large"]');
  var tapAdds = script ? script.hasAttribute('data-token-image-tap-add') : false;

  /* ---- A tile goes back to its Add button after Add to Cart ------------- */

  // The tile shows Add while its - is disabled, and - 1 + once it is not
  // (token-grid-large.css). After Add to Cart the theme sets every quantity
  // to 0 and hides the - (product-form.js), but leaves it enabled, so the
  // chosen tiles kept the stepper's look with only a round + left (merchant
  // review, Nov 3: "it doesn't revert back to the add button"). Taking a
  // token to 0 with - disables it (product.js); do the same here for any tile
  // at 0, so it looks exactly as it did before it was chosen.
  var resetTiles = function () {
    document.querySelectorAll('.tokens--container-vertical .tokenVariant').forEach(function (tile) {
      var minus = tile.querySelector('.ProductCheck .button-minus');
      var input = tile.querySelector('.ProductCheck input.quantity');
      if (!minus || !input || minus.classList.contains('disabled')) return;
      if (!(parseInt(input.value, 10) > 0)) minus.classList.add('disabled');
    });
  };
  var form = document.querySelector('.tokens--container-vertical') && document.querySelector('.tokens--container-vertical').closest('form');
  if (form) {
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(function () {
        queued = false;
        resetTiles();
      }, 0);
    }).observe(form, { subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
    resetTiles();
  }

  /* ---- Tapping a token picture adds the token ---------------------------- */

  // product.js opens the picture larger when it is tapped (merchant review,
  // Nov 3, third round: remove that, and make a tap on the picture do what
  // the Add button does). This listener runs before product.js's, stops that
  // one, and taps the tile's own + instead, which is the Add button until the
  // token is chosen. Sold-out tokens have no + to tap, so nothing happens.
  // Desktop: the + also shows the token large in the gallery on the left.
  // product.js adds that picture only the first time a token is chosen, as a
  // layer over the gallery; a later tap on the same token left whichever
  // token was chosen after it on top (merchant review, Nov 3, sixth round:
  // a tap on a chosen token must add one AND show it on the left). So after
  // the +, bring this token's picture back to the top. Phones are unchanged,
  // as asked.
  var desktop = window.matchMedia('(min-width: 992px)');
  var showOnLeft = function (tile) {
    var titleEl = tile.querySelector('.tokenTitle');
    if (!titleEl) return;
    // The same name product.js gives the picture (data-variant).
    var name = titleEl.textContent.toLowerCase().replace(/ /g, '-');
    document.querySelectorAll('.slider-for .slick-track').forEach(function (track) {
      var layers = track.querySelectorAll('.customTokenImage');
      for (var i = 0; i < layers.length; i++) {
        if (layers[i].getAttribute('data-variant') !== name) continue;
        // Last in the track is on top (the layers share one z-index). A
        // thumbnail click hides the layers (product.js); show this one again.
        if (layers[i] !== track.lastElementChild) track.appendChild(layers[i]);
        layers[i].style.display = '';
        return;
      }
    });
  };
  if (tapAdds) {
    window.addEventListener(
      'click',
      function (e) {
        var pic = e.target.closest && e.target.closest('.tokens--container-vertical .tokenVariant .tokens--variant__image');
        if (!pic) return;
        e.preventDefault();
        e.stopPropagation();
        var tile = pic.closest('.tokenVariant');
        var plus = tile.querySelector('.ProductCheck .button-plus');
        if (!plus || plus.classList.contains('disabled')) return;
        plus.click();
        if (desktop.matches) showOnLeft(tile);
      },
      true
    );
  }
})();

    }).call(window, late(document, function () { return document.readyState; }), late(window, function () { return document.readyState; }));
  }
  function check() { if (document.body && document.body.classList.contains(C)) { run(); return true; } return false; }
  if (check()) return;
  function watch() {
    if (check()) return;
    var mo = new MutationObserver(function () { if (check()) mo.disconnect(); });
    mo.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }
  if (document.body) watch(); else document.addEventListener('DOMContentLoaded', watch);
})();
